import React from 'react'
import { withJsonFormsLabelProps } from '@jsonforms/react'
import { LabelProps } from '@jsonforms/core'
import styles from '../styles/JsonForm.module.scss'
import { LayoutHeaderUISchema } from '../form-types'

type Props = Omit<LabelProps, 'uischema'> & {
  uischema: LayoutHeaderUISchema<any>
}

const LayoutHeader: React.FC<Props> = ({ uischema }) => {
  const { text, description, icon, background } = uischema

  return (
    <div className={styles.layoutLabel} style={{ backgroundColor: uischema.background }}>
      <div className={styles.titleLine}>
        <h3 className={styles.text}>{text}</h3>
      </div>
      {description && <p className={styles.description}>{description}</p>}
    </div>
  )
}

export default withJsonFormsLabelProps(LayoutHeader as any)
